/* This file was generated automatically. Do not edit manually. */

export enum AccountingCategoryClassification {
    Accommodation = 'Accommodation',
    FoodAndBeverage = 'FoodAndBeverage',
    Taxes = 'Taxes',
    Payments = 'Payments',
    ExternalRevenue = 'ExternalRevenue',
    SundryIncome = 'SundryIncome',
    Wellness = 'Wellness',
    Sport = 'Sport',
    Technology = 'Technology',
    Facilities = 'Facilities',
    Events = 'Events',
    Tourism = 'Tourism',
}
